<template>
  <div>
    <div>
      <div class="mt-10 d-flex justify-space-between heading-2">
        Licensing Information
      </div>
      <div class="mt-4">
        <v-row no-gutters align-content="center">
          <v-col cols="12" md="2" class="pt-2">
            <span class="style_txt_hh2">Fee Level </span>
          </v-col>
          <v-col cols="12" md="10">
            <span class="style_txt_hh2">
              <b>
                Level {{ GetInstructorLicensingDetails && GetInstructorLicensingDetails.Level }} - USD
                {{ GetInstructorLicensingDetails && GetInstructorLicensingDetails.TotalLicencingFees }}.00
              </b></span
            >
            <v-btn
              color="primary"
              text
              @click="openChangeLevelModal()"
              style="text-decoration: underline; text-transform: none"
              >Change</v-btn
            >
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="12" md="2">
            <span class="style_txt_hh2">Credits this period </span>
          </v-col>
          <v-col cols="12" md="10">
            <span
              class="style_txt_hh2 green--text"
              v-if=" this.GetInstructorLicensingDetails && this.GetInstructorLicensingDetails.IsCreditsApplicable"
            >
              <b>
                (USD
                {{ this.GetInstructorLicensingDetails.TotalCreditsEarned }}.00)
              </b></span
            >
            <span class="style_txt_hh2 green--text" v-else-if="this.GetInstructorLicensingDetails && this.GetInstructorLicensingDetails.IsCreditsApplicable == false">
              <b
                >(USD
                {{
                  this.GetInstructorLicensingDetails.TotalCreditsEarned
                }}.00)</b
              >
              Credits are not applicable for the first year</span
            >
          </v-col>
        </v-row>
        <v-row no-gutters class="mt-8">
          <v-col cols="12" lg="4" md="6">
            <span class="style_txt_hh2">Access graduates </span>
          </v-col>
          <v-col cols="12" lg="8" md="6">
            <v-row>
              <v-col cols="3">
                <span class="style_txt_hh2">
                  <b>
                    USD
                    {{
                      this.GetInstructorLicensingDetails && this.GetInstructorLicensingDetails.AccessGraduatesCredits
                    }}.00
                  </b></span
                >
              </v-col>
              <v-col cols="9">
                <span class="style_txt_hh2">
                  ({{
                    this.GetInstructorLicensingDetails && this.GetInstructorLicensingDetails.AccessGraduates
                  }}
                  students)
                </span>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="12" lg="4" md="6">
            <span class="style_txt_hh2"
              >Fundamentals/MindScape/BreakThrough 1 graduates
            </span>
          </v-col>
          <v-col cols="12" lg="8" md="6">
            <v-row>
              <v-col cols="3">
                <span class="style_txt_hh2">
                  <b>
                    USD
                    {{
                      this.GetInstructorLicensingDetails && this.GetInstructorLicensingDetails
                        .BodyTalkFundamentalGraduatesCredits
                    }}.00
                  </b></span
                >
              </v-col>
              <v-col cols="9">
                <span class="style_txt_hh2">
                  ({{
                    this.GetInstructorLicensingDetails && this.GetInstructorLicensingDetails
                      .BodyTalkFundamentalGraduates
                  }}
                  students)
                </span>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="12" lg="4" md="6">
            <span class="style_txt_hh2"
              >Advanced/specialized course graduates
            </span>
          </v-col>
          <v-col cols="12" lg="8" md="6">
            <v-row>
              <v-col cols="3">
                <span class="style_txt_hh2">
                  <b>
                    USD
                    {{
                      this.GetInstructorLicensingDetails && this.GetInstructorLicensingDetails
                        .SpecialCourseGraduateCredits
                    }}.00
                  </b></span
                >
              </v-col>
              <v-col cols="9">
                <span class="style_txt_hh2">
                  ({{
                    this.GetInstructorLicensingDetails && this.GetInstructorLicensingDetails.SpecialCourseGraduates
                  }}
                  students)
                </span>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </div>
    </div>
    <v-row>
      <v-col cols="12" md="6">
        <div class="mt-10 d-flex justify-space-between heading-2">
          <span>Courses Taughts</span>
        </div>
      </v-col>
      <v-col cols="12" md="6">
        <v-card flat class="d-flex justify-end mt-2">
          <div class="d-flex justify-end mt-10">
            <v-dialog
              v-model="CourseTaughtPaymentDialog"
              width="900"
              persistent
            >
              <!-- <template v-slot:activator="{ on, attrs }" class="px-10">
                <div class="d-flex justify-end">
                  <v-btn
                    rounded
                    outlined
                    color="#1884CD"
                    class=""
                    dark
                    style="
                      text-transform: none !important;
                      border: 1px solid #d2e5fc;
                    "
                    v-bind="attrs"
                    v-on="on"
                    >Add Payment</v-btn
                  >
                </div>
              </template> -->
              <v-card class="px-6 pt-8 pb-4">
                <div>
                  <CoursesTaughtPaymentComponent
                    :CourseTaughtPaymentProcess="CourseTaughtPaymentDialog"
                    @close="close"
                  />
                </div>
              </v-card>
            </v-dialog>
            <v-btn
              @click="addDialog = true"
              rounded
              outlined
              color="#1884CD"
              class="mx-4"
              dark
              style="text-transform: none !important; border: 1px solid #d2e5fc"
              >Add Course
            </v-btn>
            <!-- <router-link to="/seminars"> -->
              <v-btn
                rounded
                outlined
                color="#1884CD"
                dark
                @click="openSeminarDialog()"
                style="
                  text-transform: none !important;
                  border: 1px solid #d2e5fc;
                "
                >View Seminars
              </v-btn>
            <!-- </router-link> -->
          </div>
        </v-card>
      </v-col>
    </v-row>
    
    <div>
      <v-card class="my-6" outlined>
        <v-data-table
          :headers="headers"
          :items="getCourseTaught"
          :loading="btnloader"
          loading-text="Loading... Please wait"
          disable-pagination
          hide-default-footer
        >
          <template v-slot:[`item.DateStarted`]="{ item }">
            <span class="index_span_2_style">
              {{ item.DateStarted?.split("T")[0].replaceAll("-", "/") }}
            </span>
          </template>
          <template v-slot:[`item.DateGraduated`]="{ item }">
            <span class="index_span_2_style">
              {{ item.DateGraduated?.split("T")[0].replaceAll("-", "/") }}
            </span>
          </template>
          <template v-slot:[`item.certificate`]="{ item }">
            <v-icon color="#A1A1A6" @click="viewCertificate(item)">
              mdi-file-document
            </v-icon>
          </template>
          <!-- <template v-slot:[`item.Course`]="{ item }">
            <span class="index_span_2_style">
              {{ item.Course }}
            </span>
          </template> -->
          <!-- <template v-slot:[`item.traninginstructor`]="{ item }">
            <span class="index_span_2_style">
              {{ item.traninginstructor }}
            </span>
          </template> -->
          <!-- <template v-slot:[`item.credentials`]="{ item }">
            <span class="index_span_2_style">
              {{ item.credentials }}
            </span>
          </template> -->
          <!-- <template v-slot:[`item.certificate`]>
            <v-icon> mdi-file-pdf-box </v-icon>
          </template> -->

          <template v-slot:[`item.actions`]="{ item }">
            <v-menu
              transition="scroll-y-transition"
              offset-y
              color="transparent"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-icon color="A1A1A6" v-bind="attrs" v-on="on">
                  mdi-dots-horizontal
                </v-icon>
              </template>
              <v-card flat>
                <v-list class="px-3 pt-1" color="transparent">
                  <div class="d-flex">
                    <v-btn
                      depressed
                      color="transparent"
                      block
                      class="d-flex justify-start"
                      @click="editCourseTaught(item)"
                    >
                      <v-icon color="#646464"> mdi-pencil</v-icon>
                      <span class="ml-4 text_style">Edit</span>
                    </v-btn>
                  </div>
                </v-list>
                <v-list class="px-3 pt-1" color="transparent">
                  <div class="d-flex">
                    <v-btn
                      depressed
                      color="transparent"
                      block
                      class="d-flex justify-start"
                      @click="deleteCourseTought(item.Id)"
                    >
                      <v-icon color="#646464">mdi-delete</v-icon>
                      <span class="ml-4 text_style">Delete </span>
                    </v-btn>
                  </div>
                </v-list>
              </v-card>
            </v-menu>
          </template>
        </v-data-table>
      </v-card>
      <v-dialog v-model="editDialog" persistent max-width="500">
        <v-card v-if="editDialog">
          <div>
            <editcourses
              :editDialog="editDialog"
              :courseTaughtData="courseTaught"
              @close="close"
            />
          </div>
        </v-card>
      </v-dialog>
      <v-dialog v-model="addDialog" persistent max-width="500">
        <v-card v-if="addDialog">
          <div>
            <addcoursetab :addDialog="addDialog" @close="close" />
          </div>
        </v-card>
      </v-dialog>
      <v-dialog v-model="seminarDialog" max-width="800">
        <v-card class="py-4 pl-4 pr-2" flat outlined>
          <span style="font-family: 'Lora';
            font-style: normal;
            font-weight: 700;
            font-size: 34px;
            line-height: 60px;
            letter-spacing: -0.02em;
            color: #222222;">Seminars 
          </span>
          <v-data-table
            :headers="seminarHeaders"
            :items="GetSeminars && GetSeminars"
            hide-default-footer
            :items-per-page="50"
            :loading="tableLoader"
            style="max-height:600px; overflow-y:auto;"
          >
            <template v-slot:[`item.index`]="{ index }">
              <b> {{ index + 1 }} </b>
            </template>
            <template v-slot:[`item.Location`]="{ item }">
              <span class="table_style_two" v-if="item.Location">
                {{ item.Location && item.Location.LocationName }}, {{ item.Location && item.Location.City }},
                {{ item.Location && item.Location.Country }}
              </span>
            </template>
            <template v-slot:[`item.Instructor`]="{ item }">
              <span class="table_style_two">
                {{ item.Instructor?.FirstName }}
                {{ item.Instructor?.LastName }}
              </span>
            </template>
            <template v-slot:[`item.SeminarDateAndTimes`]="{ item }">
              <div>
                <span class="table_style_two">
                  {{ item.SeminarDateAndTimes[0].Date?.split("T")[0] }}</span
                >
              </div>
            </template>
          </v-data-table>
        </v-card>
      </v-dialog>
    </div>

      
    <v-dialog v-model="changeLevelDialog" max-width="600">
      <v-card class="pa-7" v-if="changeLevelDialog">
        <div class="d-flex align-center justify-space-between">
          <h4>Change Level</h4>
          <v-icon @click="closeChangeLevelModal()">mdi-close</v-icon>
        </div>
        <div class="mt-7">
          <div class="d-flex align-center">
            User:
            <b class="mx-3"
              >{{ this.GetPreviewUser.FirstName }}
              {{ this.GetPreviewUser.LastName }}</b
            >
          </div>
          <div class="my-3 d-flex align-center">
            Current Licensing level:
            <b class="mx-3">{{ this.GetInstructorLicensingDetails && this.GetInstructorLicensingDetails.Level }}</b>
          </div>
          <div class="my-3 d-flex align-center">
            Change Licensing level:
            <v-autocomplete
              :items="licensinglevelList"
              item-text="name"
              item-value="id"
              class="mx-3"
              v-model="instructorLevel"
              :error-messages="
              $v.instructorLevel.$error ? 'instructorLevel is required' : null
            "
            ></v-autocomplete>
          </div>
          <div
            class="d-flex align-center my-5"
            style="font-style: italic; color: #838383"
          >
            Note: Licensing level is set to the Membership renewal cycle. If a
            User becomes an Instructor (or changes their license level) in the
            middle of their yearly membership billing cycle, the licensing fees
            will be billed at their next renewal date. Student credits will
            start to accrue once the licensing fees are paid at the next renewal
            date.
          </div>
          <div class="d-flex align-center justify-space-around">
            <v-btn
              color="#838383"
              class="px-12"
              outlined
              @click="closeChangeLevelModal()"
              >Cancel</v-btn
            >
            <v-btn
              color="primary "
              class="px-12"
              :disabled="btnloader"
              @click="updateLevel"
            >
              <span v-if="btnloader != true">Update</span>
              <v-progress-circular
                indeterminate
                size="20"
                v-else
                class="px-5"
                color="white"
                v-show="btnloader"
              ></v-progress-circular>
            </v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="viewCertificateDialog" max-width="1100">
      <v-card class="pa-4" v-if="viewCertificateDialog">
        <template v-for="(certificate,index) in certificatesList">
          <template v-if="certificate.templateName === templateName">
          <component
            :is="certificate.certificate"
            :key="index"
            :userData="userCertificateDetails"
            />
          </template>
        </template>
      </v-card>
    </v-dialog>    
  </div>
</template>

<script>
import Addcoursetab from "./addcoursetab.vue";
import { required } from "vuelidate/lib/validators";
import editcourses from "./editcourses.vue";
import BATCertificate from "./BATCertificate.vue";
import BRICertificate from "./BRICertificate.vue";
import CBICertificate from "./CBICertificate.vue";
import FFICertificate from "./FFICertificate.vue";
import CBIACertificate from "./CBIACertificate.vue";
import MSICertificate from "./MSICertificate.vue";
import CoursesTaughtPaymentComponent from "../../../components/Users/paymentcomponents/CoursesTaughtPayment.component.vue";
import { mapGetters } from "vuex";
export default {
  components: { 
    editcourses, Addcoursetab, CoursesTaughtPaymentComponent, 
    BATCertificate, 
    BRICertificate,
    CBICertificate, 
    CBIACertificate, 
    MSICertificate,
    FFICertificate,
  },

  data() {
    return {
      seminarDialog:false,
      licensinglevelList: [
        { name: "Level 0 - $0", id: 0 },
        { name: "Level 1 - $100", id: 1 },
        { name: "Level 2 - $200", id: 2 },
        { name: "Level 3 - $450", id: 3 },
      ],
      certificatesList: [
        {
          templateName: "BAT",
          certificate: "BATCertificate",
        },
        {
          templateName: "BrI",
          certificate: "BRICertificate",
        },
        {
          templateName: "CBI",
          certificate: "CBICertificate",
        },
        {
          templateName: "CBI-A",
          certificate: "CBIACertificate",
        },
        {
          templateName: "MSI",
          certificate: "MSICertificate",
        },
        {
          templateName: "FFI",
          certificate: "FFICertificate",
        },
      ],
      viewCertificateDialog: false,
      templateName:'',
      changeLevelDialog: false,
      instructorLevel: null,
      CourseTaughtPaymentDialog: false,
      editDialog: false,
      courseTaught: "",
      addDialog: false,
      btnloader: false,
      filtersArray: [
        {
          Key: "CreatedBy",
          Value: null,
        },
      ],
      headers: [
        { text: "Date Started", value: "DateStarted", sortable: false },
        { text: "Date Graduated", value: "DateGraduated", sortable: false },
        { text: "Course of Study", value: "Title", sortable: false },
        {
          text: "Training Instructor",
          value: "Instructor",
          sortable: false,
        },
        { text: "Credential", value: "CredentialEarned", sortable: false },
        { text: "Certificate", value: "certificate", sortable: false }, 
        // { text: "Certificate", value: "certificate", sortable: false },
        { text: "", value: "actions", sortable: false },
      ],
      seminarHeaders: [
        { text: "#", value: "index", sortable:false },
        { text: "Course", value: "Course.Title" },
        { text: "Location", value: "Location", sortable:false },
        { text: "Instructor", value: "Instructor", sortable:false },
        { text: "Start Date", value: `SeminarDateAndTimes` },
        { text: "Status", value: "Status" },
      ],
      coursesDataTable: [
        {
          datestart: "08/13/2022",
          courses: "Body talk Fundamentals Extensions",
          traninginstructor: "SrCBI",
          credentials: "Yes",
          dateend: "16/12/2021",
          certificate: "Website",
        },
        {
          datestart: "08/13/2022",
          courses: "Body talk Fundamentals Extensions",
          traninginstructor: "SrCBI",
          credentials: "Yes",
          dateend: "16/12/2021",
          certificate: "Website",
        },
        {
          datestart: "08/13/2022",
          courses: "Body talk Fundamentals Extensions",
          traninginstructor: "MSI",
          credentials: "Yes",
          dateend: "16/12/2021",
          certificate: "Website",
        },
        {
          datestart: "08/13/2022",
          courses: "Body talk Fundamentals Extensions",
          traninginstructor: " CBI-A",
          credentials: "Yes",
          dateend: "16/12/2021",
          certificate: "Website",
        },
      ],
      courses: [],
    };
  },
  computed: {
    ...mapGetters([
      "GetCourses",
      "GetPreviewUser",
      "getCourseTaught",
      "GetInstructorLicensingDetails",
      "GetSeminars",
      "GetCoursesIDsAndTitle"
    ]),
  },
  validations:{
    instructorLevel:{
      required
    }
  },
  mounted() {
    this.filtersArray[0].Value = this.GetPreviewUser.Id
    this.getInstructorLicensingDetails()
    this.fetchData();
    if(this.GetCoursesIDsAndTitle.length == 0){
      this.$store.dispatch("GetCoursesIDsAndTitle")
    }
    const payload = {
      search: "",
      pageSize: "All",
      page: 1,
      filters: JSON.stringify(this.filtersArray),
    };
    this.$store.dispatch("GetAllSeminar", payload)
  },
  methods: {
    viewCertificate(item) {
      this.userCertificateDetails = item
      this.templateName = item.CredentialEarned?.trim()
      this.viewCertificateDialog = true;
    },
    openChangeLevelModal(){
      this.changeLevelDialog = true
      this.instructorLevel = null
    },
    closeChangeLevelModal(){
      this.changeLevelDialog = false
      this.instructorLevel = null
    },
    openSeminarDialog(){
      this.seminarDialog = true;
    },
    getInstructorLicensingDetails(){
      this.$store.dispatch("GetInstructorLicensingDetails",this.GetPreviewUser.Id);
    },
    fetchData() {
      this.btnloader = true;
      this.$store.dispatch("GetCourseTaught", this.GetPreviewUser.Id).then(()=>{
      this.btnloader = false;
      });
    },
    updateLevel() {
      this.$v.$touch()
      if(this.$v.$invalid){
        return
      }
      this.btnloader = true;
      this.$store.dispatch("ChangeInstructorLevel", {
        instructorLevel: this.instructorLevel,
        instructorId: this.GetPreviewUser.Id,
      }).then((res)=>{
        this.changeLevelDialog = false
        this.$v.$reset()
        if(res.data.Message == "No Instructor Found"){
        this.btnloader = false;
        this.getInstructorLicensingDetails()
          this.$swal.fire({
            toast: true,
            icon: "error",
            position: "top-end",
            title: res.data.Message,
            showConfirmButton: false,
            timer: 3000,
          });
          return
        }
        this.btnloader = false;
        this.getInstructorLicensingDetails()
          this.$swal.fire({
            icon: "success",
            title: "Level updated successfully",
            showConfirmButton: false,
            timer: 3000,
          });
      })
    },
    close() {
      this.editDialog = false;
      this.addDialog = false;
      this.CourseTaughtPaymentDialog = false;
      this.fetchData();
    },
    editCourseTaught(courseTaught) {
      this.courseTaught = courseTaught;
      this.editDialog = true;
    },
    deleteCourseTought(id) {
      this.$store.dispatch("DeleteCourseTaught", id).then(() => {
        this.fetchData();
      });
    },
  },
};
</script>

<style></style>
